export default "__VITE_ASSET__59f43856__"